export const arcFlowersConfig = {
    geometry: {
        width: 835,
        height: 889,
        scale: 0.095
    },
    textures: [
        {
            src: 'assets/images/textures/flower-arc-frame-1024x1024.png',
            ratio: 1
        }
    ]
};

export const frameFlowersConfig = {
    geometry: {
        width: 514,
        height: 670,
        scale: 0.2
    },
    textures: [
        {
            src: 'assets/images/textures/flower-frame-512x1024.png',
            ratio: 1
        }
    ]
};
